import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { i18nReady } from "@/i18n";
import { initAnalytics } from "@/lib/analytics/analytics";
import { captureAttribution } from "@/lib/analytics/attribution";
import { initErrorReporting } from "@/lib/core/errors";
import "@/lib/pwa/install"; // listens for the install prompt before React renders
import "./styles.css";
import { z } from "zod";

// zod probes eval() support at first use; the Content-Security-Policy forbids it (console error).
z.config({ jitless: true });

// After a deploy, a tab still on the old build asks for chunks that are gone: reload once into the
// new build instead of showing a blank page (at most every 10 s, so a real outage cannot loop).
window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem("chunk-reload") ?? 0);
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem("chunk-reload", String(Date.now()));
  } catch {
    // Storage blocked: still reload once.
  }
  event.preventDefault();
  window.location.reload();
});

void initErrorReporting();
initAnalytics();
captureAttribution();

// Render once the user's language has loaded (English is bundled; others are a small chunk),
// so the first paint is never in the wrong language. A failed load still renders, in English.
void i18nReady.finally(() =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);
